export default __webpack_public_path__ + "static/media/icono_ubicacion.5f986221.svg";